/**
 * Session-aware navigation actions. Moving to the builder also drives session
 * lifecycle (sessionActive / autoStartVoice / entryGreeting) and, when fresh,
 * clears the in-memory stores — centralized here so the choreography lives in
 * one place.
 */

import { useSocketStore } from "../store/socketStore";
import { useStoryStore } from "../store/storyStore";
import { useComicStore } from "../store/comicStore";
import { useNavigationStore } from "./navigationStore";

interface StartBuilderOptions {
  /** Start a brand-new story: clear stores + tell the server, and greet as "new". */
  fresh?: boolean;
}

/**
 * Enter the builder screen and arm the voice session. With `fresh`, also clears
 * the current story/comic/config locally and on the server ("Create new story").
 */
export function startBuilderSession({ fresh = false }: StartBuilderOptions = {}): void {
  if (fresh) {
    useStoryStore.getState().clearAll();
    useComicStore.getState().clearAll();
    useSocketStore.getState().socket?.emit("clearStory");
  }
  useSocketStore.setState({
    sessionActive: true,
    ...(fresh ? { autoStartVoice: true, entryGreeting: "new" as const } : {}),
  });
  useNavigationStore.getState().resetToBuilder();
}
